<template>
  <div>
    <SelectItems
      label="name"
      v-model="internalFields.value"
      :items="orderStatusItems"
      :loading="loading"
      :placeholder="placeholder"
      :disabled="disabled"
      :reduceFunction="(orderStatus) => orderStatus.id"
    />
  </div>
</template>

<script>
import ORDER_STATUS from 'Enums/Order/Status.js';
import SelectItems from './SelectItems.vue';

export default {
  name: 'SelectOrderStatus',
  model: {
    prop: 'value',
    event: 'update:value',
  },
  props: {
    value: {
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Status do pedido',
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      internalFields: {
        value: '',
      },
    };
  },
  watch: {
    'internalFields.value': function () {
      this.$emit('update:value', this.internalFields.value);
    },
    value() {
      this.internalFields.value = this.value;
    },
  },
  computed: {
    orderStatusItems() {
      const items = [];

      Object.keys(ORDER_STATUS).forEach((key) => {
        items.push({
          id: ORDER_STATUS[key],
          name: this.getOrderStatusText(ORDER_STATUS[key]),
        });
      });

      return items;
    },
  },
  created() {
    this.internalFields.value = this.value;
  },
  methods: {
    getOrderStatusText(status) {
      const texts = {
        [ORDER_STATUS.WAITING_PAYMENT]: 'Aguardando pagamento',
        [ORDER_STATUS.SEPARATING_ORDER]: 'Separando pedido',
        [ORDER_STATUS.SENT]: 'Saiu para entrega',
        [ORDER_STATUS.READY_FOR_PICKUP]: 'Pronto para retirada',
        [ORDER_STATUS.DELIVERED]: 'Entregue',
        [ORDER_STATUS.CANCELED]: 'Cancelado',
        [ORDER_STATUS.EXPIRED]: 'Expirado'
      };

      return texts[status] || 'N/A';
    },
  },
  components: {
    SelectItems,
  },
};
</script>